<template>
  <button class="close-notification" aria-label="close" @click.stop="(ev) => $emit('click', ev)">
    <svg version="1.1" id="UNIQ_FID_appimagesicons-to-fontclose--UFI--Layer_1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
        <path d="M0.7,2.9L0.7,2.9C0.7,2.9,0.7,2.9,0.7,2.9L0.7,2.9z M31.1,29.6L17.3,16.2L30.7,2.4C31,2,31,1.4,30.6,1c-0.4-0.4-1-0.4-1.4,0
          L15.9,14.8L2.1,1.4c0,0,0,0,0,0c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l13.8,13.4L1.1,30c0,0,0,0,0,0c-0.4,0.4-0.4,1,0,1.4
          c0.4,0.4,1,0.4,1.4,0h0l13.4-13.8L29.7,31c0.4,0.4,1,0.3,1.4,0C31.5,30.6,31.5,30,31.1,29.6z" />
      </svg>
  </button>
</template>

<script>
export default {
  name: 'close-notification-button'
};
</script>

<style lang="scss" scoped>
.close-notification {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  margin-left: 1rem;
  opacity: 1;

  svg {
    width: 0.875rem;
    height: 100%;
    fill: $context-color-3;
  }

  &:hover svg {
    fill: $context-color-1;
  }
}
</style>
